import type { RadioGroupProps } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Radio from './Radio';

type YesNoRadioProps = {
  yesValue?: boolean,
  noValue?: boolean,
} & RadioGroupProps;

const YesNoRadio: React.FC<YesNoRadioProps> = ({ yesValue = true, noValue = false, ...rest }) => {
  const options = React.useMemo(
    () => [
      { value: yesValue, label: <FormattedMessage id="yes" defaultMessage="Yes" /> },
      { value: noValue, label: <FormattedMessage id="no" defaultMessage="No" /> },
    ],
    [yesValue, noValue]
  );

  return <Radio.Group {...rest} options={options} />;
};

export default YesNoRadio;
